import Axios from 'axios'
import Qs from 'Qs'
import { Message, MessageBox } from 'element-ui'
import auth from '../utils/auth'


const http = Axios.create({
    baseURL: '/api/cms',
    timeout: 600000, // 请求超时时间
    withCredentials: true
})

// 请求拦截器
http.interceptors.request.use(request => {
    // request.headers['token'] = 'token'
    return request
}, error => {
    Promise.reject(error)
})

// 响应拦截器
const duration = 3000 // 提示消息框持续时间
http.interceptors.response.use(
    response => {
        const rs = response.data
            // 请求结果失败
        if (response.status !== 200) {
            Message({
                message: '网络错误',
                type: 'error',
                duration: duration
            })
            return
        }
        // 未登录
        if (rs.status === -100) {
            auth.removeToken()
            MessageBox.confirm('用户已超时，可以取消继续留在该页面，或者重新登录', '提示', {
                confirmButtonText: '重新登录',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                location.reload()
            })
            return
        }
        // 没有权限
        if (rs.status === -101) {
            Message({
                message: '没有权限',
                type: 'error',
                duration: duration
            })
            return
        }
        // 其他，状态码小于0
        if (rs.status !== 1) {
            Message({
                message: rs.msg,
                type: 'error',
                duration: duration
            })
            return
        }
        return response.data
    },
    error => {
        Message({
            message: error.message,
            type: 'error',
            duration: duration
        })
        return Promise.reject(error)
    }
)

export default http


// WEBPACK FOOTER //
// ./src/utils/http.js